"use client";

import { type DialogTriggerProps, Trigger as TriggerPrimitive } from "@radix-ui/react-dialog";
import { Slot } from "@radix-ui/react-slot";

import { useDialogNestedContext } from "./stack/context";

export type { DialogTriggerProps } from "@radix-ui/react-dialog";

const Trigger = ({ asChild, onClick, ...props }: DialogTriggerProps) => {
  const nested = useDialogNestedContext();

  if (!nested) {
    return <TriggerPrimitive asChild={asChild} onClick={onClick} {...props} />;
  }

  const Comp = asChild ? Slot : "button";

  return (
    <Comp
      type={asChild ? undefined : "button"}
      aria-haspopup="dialog"
      aria-expanded={nested.open}
      data-state={nested.open ? "open" : "closed"}
      onClick={event => {
        onClick?.(event);
        if (!event.defaultPrevented) {
          nested.setOpen(true);
        }
      }}
      {...props}
    />
  );
};

Trigger.displayName = TriggerPrimitive.displayName;

export default Trigger;
